import { getAPI, postAPI } from "../../api/api";
import { REACT_APP_CANDIDATEFILTER } from "../../utils/common";


export async function uploadHistory( pageSize: number, pageNumber: number, searchValue: string, filters?: any, sort?: any) {

    let merge = {filter:{
        "added_by": "12345678-393a-4183-bbd0-f55bc49663f11",
        "time": {
            "from":"1666184319000",
            "to":"1666270719000"
    } }
};
  
  
      const Details = postAPI(REACT_APP_CANDIDATEFILTER + `/getCandidatePublicData`, merge)
      return Details
   
  }
  